export default __webpack_public_path__ + "static/media/Summoner's Crown of Regal Might.19d43918.jpg";